<template>
  <section class="order-item">
    <div
      :is="componentToRender"
      :item="item"
      :showhotels="showhotels"
    />
  </section>
</template>

<script>
import HotelOnlyVersion1 from './version_1/hotel_only_item'
import PackageAndHotelH4H from './h4h/package_and_hotel_item'
import PackageAndHotelVersion1 from './version_1/package_and_hotel_item'
import PackageOnlyH4H from './h4h/package_only'
import PackageOnlyVersion1 from './version_1/package_only_item'

export default {

  components: {
    HotelOnlyVersion1,
    PackageAndHotelH4H,
    PackageAndHotelVersion1,
    PackageOnlyH4H,
    PackageOnlyVersion1
  },

  props: {
    cartversion: {
      default: 'version_1',
      type: String,
      required: false,
    },

    item: {
      required: true
    },
    showhotels:{
      required: false
    }
  },
  computed: {
    componentToRender() {
      if(this.packageOnlyH4H) {
        return PackageOnlyH4H
      } else if (this.packageOnly) {
        return PackageOnlyVersion1
      } else if (this.hotelOnly) {
        return HotelOnlyVersion1
      } else if (this.h4hItemDisplay) {
        return PackageAndHotelH4H
      } else {
        return PackageAndHotelVersion1
      }
    },

    hotelOnly() {
      return this.item.package_price <= 0
    },

    h4hItemDisplay() {
      return this.cartversion == 'h4h'
    },

    packageOnly() {
      return this.item.hotel_id == null
    },

    packageOnlyH4H() {
      return this.h4hItemDisplay && this.packageOnly
    }
  }
}
</script>
